// Module-scoped state for the v3 settings sidebar's Back button. Captured when
// the user enters the settings hierarchy via the Settings menu item, read when
// the user clicks Back. Lives across sub-navigations within the settings rail
// (because nothing else writes to it), and resets on page reload (because the
// module re-initializes). See nav-v3 plan: settings Back returns to the page
// the user was on before entering settings, not the previous settings page.

let storedBackHref: string | null = null

export const setSettingsBackHref = (href: string | null): void => {
  storedBackHref = href
}

export const getSettingsBackHref = (): string | null => storedBackHref
